<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <vx-card
      class="mb-2"
      :title="`دریافت کنندگان قبض ${'&quot;'+this.$route.params.title+'&quot;'}`"
    >
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="back"
            type="flat"
            icon-pack="feather"
            icon="icon-chevron-right"
          >بازگشت</vs-button>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col md:w-1/3 w-full">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">تاریخ صدور:</div>
            <div
              class="vx-col sm:w-2/3 flex-inline"
            >{{$moment(tableData.billDate).format('jYYYY/jM/jD')}}</div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">ساعت صدور:</div>
            <div
              class="vx-col sm:w-2/3 flex-inline"
            >{{$moment(tableData.billDate).format('HH:mm:ss')}}</div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">عنوان:</div>
            <div class="vx-col sm:w-2/3 flex-inline">{{tableData.title}}</div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">توضیحات:</div>
            <div class="vx-col sm:w-2/3 flex-inline">{{tableData.description}}</div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">کل مبلغ:</div>
            <div
              class="vx-col sm:w-2/3 flex-inline"
            >{{parseInt(tableData.totalAmount).toLocaleString()}}</div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/3 flex-inline">مبلغ پرداخت شده:</div>
            <div
              class="vx-col sm:w-2/3 flex-inline"
            >{{parseInt(tableData.paidAmount).toLocaleString()}}</div>
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full d-only">
          <span class="ml-6">مبلغ:</span>
          <vue-apex-charts
            type="donut"
            height="350"
            :options="amountChart.chartOptions"
            :series="amountChart.series"
          ></vue-apex-charts>
        </div>
        <div class="vx-col md:w-1/3 w-full d-only">
          <span class="ml-6">تعداد:</span>
          <vue-apex-charts
            type="donut"
            height="350"
            :options="qtyChart.chartOptions"
            :series="qtyChart.series"
          ></vue-apex-charts>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- pagination :max-items="100" -->
      <vs-table
        id="tbl2"
        ref="tbl2"
        :max-items="paginationPageSize"
        stripe
        :data="filterdData"
        class="responsable-table"
      >
        <template slot="header">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <vs-button
                    @click="fillTable"
                    class="mx-3"
                    color="success"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                  ></vs-button>
                </div>

                <div class="vx-col">
                  <vs-button
                    @click="download"
                    class="mx-3"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-download"
                  >دانلود</vs-button>
                </div>

                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo-1)*pageSize +1}}
                          -
                          {{ (pageNo)*pageSize>totalCount?totalCount:(pageNo)*pageSize }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
                <div class="vx-col">
                  <vs-input
                    icon-pack="feather"
                    icon="icon-search"
                    placeholder="جستجو"
                    v-model="filterText"
                    class="is-label-placeholder mt-0"
                  />
                </div>
                <div class="vx-col w-full">
                  <vs-tabs>
                    <vs-tab @click="filterData(-1)" label="همه" class="activeChild"></vs-tab>
                    <vs-tab @click="filterData(0)" label="در انتظار پرداخت"></vs-tab>
                    <vs-tab @click="filterData(1)" label="پرداخت شده"></vs-tab>
                    <vs-tab @click="filterData(2)" label="رد شده"></vs-tab>
                  </vs-tabs>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th class="px-1">ردیف</vs-th>
          <vs-th sort-key="consumerName" key="consumerName">نام مشتری</vs-th>
          <vs-th sort-key="consumerMobile" key="consumerMobile">شماره مشتری</vs-th>
          <vs-th sort-key="amount" key="amount">مبلغ</vs-th>
          <vs-th sort-key="paymentTransactionDateTime" key="paymentTransactionDateTime">تاریخ پرداخت</vs-th>
          <vs-th sort-key="merchantDescription" key="merchantDescription">سایر</vs-th>
          <vs-th sort-key="billState" key="billState">وضعیت</vs-th>
          <vs-th>لینک پرداخت</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="pr-0 d-only">{{pageSize*(pageNo-1)+indextr+1}}</vs-td>
            <vs-td>{{tr.consumerName}}</vs-td>
            <vs-td>{{tr.consumerMobile==null?(/^(\+98|0)9\d{9}$/.test(tr.consumerName)?tr.consumerName:''):tr.consumerMobile}}</vs-td>
            <vs-td>{{parseInt(tr.amount).toLocaleString()}}</vs-td>
            <vs-td class="e-col">
              {{tr.billState==1
              ?(!tr.paymentTransactionDateTime||tr.paymentTransactionDateTime=='0001-01-01T00:00:00') ?'-':$moment(tr.paymentTransactionDateTime).format('HH:mm:ss - jYYYY/jM/jD')
              :'-'}}
            </vs-td>    
            <vs-td class="e-col hide-title py-0">
              <template
                v-if="!$helper.isJSON(tr.merchantDescription)"
              >{{tr.merchantDescription}}</template>
              <template v-else>
                <span
                  class="mx-0 block py-1"
                  :key="item"
                  v-for="item in (tr.merchantDescription)?Object.keys(JSON.parse(tr.merchantDescription)):[]"
                >
                  <span class="text-grey">{{item}}:</span>
                  {{JSON.parse(tr.merchantDescription)[item]}}
                </span>
              </template>
            </vs-td>
            <vs-td  class="d-only">
              <feather-icon
                :title="BillState[tr.billState].title"
                :icon="BillState[tr.billState].icon"
                :svgClasses="[`h-6 w-6 stroke-current text-${BillState[tr.billState].color}`]"
              ></feather-icon>
            </vs-td>
            <vs-td class="d-only px-2">
              <share-links
                :cssClass="'text-'+BillState[tr.billState].color"
                :message="'https://pay.bistpay.com/2/2/'+tr.billReciverId"
                btnText="اشتراک"
              ></share-links>
            </vs-td>
            <vs-td class="d-only px-2">
              <vs-button
                color="success"
                type="line"
                class="pb-1 px-0 one-line"
                v-if="tr.billState==1"
                @click="showTransaction(tr.transactionId)"
              >تراکنش</vs-button>
              <vs-button
                color="warning"
                type="line"
                class="pb-1 px-0"
                v-else-if="tr.billState==0"
                target="_blunk"
                :href="`https://pay.bistpay.com/2/2/${tr.billReciverId}`"
              >پرداخت</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination :total="pagesCount" v-model="pageNo" @input="(val) => { filterData() }" />
    </vx-card>
    <transaction-details ref="TransactionDetails1"></transaction-details>
  </div>
</template>
<style>
.remove-nav {
  background: #ea5455;
  color: #eee;
}
.excel-import div,
.remove-nav {
  padding-top: 0 !important;
  padding-bottom: 17px !important;
}
.excel-import div span,
.remove-nav span {
  display: inline-block !important;
  bottom: -1em;
  margin-left: 1em;
}
.is-blocked {
  border-width: 0;
  border-left-width: 6px;
  border-right-width: 6px;
  border-style: dashed;
  border-color: red;
}
</style>
<script>
import VueApexCharts from "vue-apexcharts";
//import apexChatData from './apexChartData.js'
import ShareLinks from "./ShareLinks.vue";
import json2xlsx from "json2xlsx-export";
import TransactionDetails from "../transaction/TransactionDetails.vue";
import { BillState } from "@/enums.js";
export default {
  name: "bill-receivers",
  components: {
    VueApexCharts,
    ShareLinks,
    TransactionDetails,
  },
  data() {
    return {
      tableData: [],
      filterdData: [],
      paginationPageSize: 20,
      filterText: "",
      qtyChart: {
        series: [0, 100],
        //series: [tableData.paidAmount, tableData.totalAmount],
        chartOptions: {
          labels: ["پرداخت شده", "پرداخت نشده", "رد شده"],
          colors: ["#28C76F", "#ff6720", "#FF9F43"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
      amountChart: {
        series: [0, 100],
        //series: [tableData.paidAmount, tableData.totalAmount],
        chartOptions: {
          labels: ["پرداخت شده", "پرداخت نشده", "رد شده"],
          colors: ["#28C76F", "#ff6720", "#FF9F43"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      billState: -1,
      BillState,
    };
  },
  props: {},
  watch: {
    tableData: {
      handler: function (newValue) {
        this.qtyChart.series = [
          newValue.paidCount,
          newValue.pendingCount,
          newValue.canceledCount,
        ];
        this.amountChart.series = [
          newValue.paidAmount,
          newValue.pendingAmount,
          newValue.canceledAmount,
        ];
      },
      deep: true,
    },
    filterText: {
      handler: function (newValue) {
        this.filterData();
      },
    },
  },
  computed: {},
  methods: {
    back() {
      //this.$emit("close");
      this.$router.back();
    },
    fillTable() {
      let params = this.$route.params;
      let payload = {
        params: {
          //pageNumber: this.pageNo,
          pageSize: 99999, //this.pageSize,
          BillId: this.$route.params.billId,
          GetAllState: true,
          //BillState
        },
      };
      this.$http
        .get("api/services/app/Bills/GetListBillReceiversForMerchant", payload)
        .then((response) => {
          this.tableData = response.data.result.items;
          console.log(this.tableData)
          this.pageNo = 1;
          this.filterData();
        }) //end success
        .catch((error) => {}); //end http
    },
    filterData(state = null) {
      if (!this.tableData || !this.tableData.billRecivers) return;
      if (state != null) {
        this.pageNo = 1;
        this.billState = state;
      }
      let fd = this.tableData.billRecivers.filter((x) => {
        return (
          (this.filterText == "" ||
            x.consumerMobile.includes(this.filterText) ||
            x.consumerName.includes(this.filterText) ||
            (x.billState == 1 &&
              this.$moment(x.paymentTransactionDateTime)
                .format("HH:mm:ss - jYYYY/jM/jD")
                .includes(this.filterText)) ||
            x.amount.toString().includes(this.filterText)) &&
          (this.billState == "-1" || x.billState == this.billState)
        );
      });
      this.filterdData = fd.filter((x, i) => {
        return (
          i >= (this.pageNo - 1) * this.pageSize &&
          i < this.pageNo * this.pageSize
        );
      });
      this.totalCount = fd.length;
      this.pagesCount = Math.floor((this.totalCount - 1) / this.pageSize) + 1;
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.filterData();
    },
    showTransaction(id) {
      this.$refs.TransactionDetails1.show(id);
    },
    download() {
      const fileName = this.tableData.title;
      const exportType = "xls";
      const data = this.filterdData.map((x) => {
        return [
          { value: x.consumerName, type: "string" },
          {
            value:
              x.consumerMobile == null
                ? /^(\+98|0)9\d{9}$/.test(x.consumerName)
                  ? x.consumerName
                  : ""
                : x.consumerMobile,
            type: "string",
          },
          { value: x.amount, type: "string" },
          { value: BillState[x.billState].title, type: "string" },
          {
            value:
              x.paymentTransactionDateTime == undefined ||
              x.paymentTransactionDateTime == "0001-01-01T00:00:00"
                ? "-"
                : this.$moment(x.paymentTransactionDateTime).format(
                    "HH:mm:ss - jYYYY/jM/jD"
                  ),
            type: "string",
          },
        ];
      });
      const header = [
        [
          {
            value: "نام پرداخت کننده",
            type: "string",
          },
          {
            value: "موبایل پرداخت کننده",
            type: "string",
          },
          {
            value: "مبلغ",
            type: "string",
          },
          {
            value: "وضعیت",
            type: "string",
          },
          {
            value: "تاریخ پرداخت",
            type: "string",
          },
        ],
      ];
      const data2 = [...header, ...data];
      const config = {
        filename: fileName,
        sheets: [
          {
            name: fileName,
            data: data2,
          },
        ],
      };

      json2xlsx(config);
    },
  },
  mounted() {
    this.fillTable();
  },
};
</script>
